<template>
	<div class="image-gallery">
		<div class="thumbnails-box">
			<button class="prev-btn" @click="prevImage" v-if="images.length > 3">
				<img src="../assets/MyOrder/iconH.png">
			</button>
			<div class="thumbnails-container" ref="thumbnailContainer">
				<div class="thumbnails">
					<div class="thumbnail" v-for="(image, index) in images" :key="index">
						<img :src="image" alt="Thumbnail" :class="{ active: image === selectedImage && images.length > 3 }" />
					</div>
				</div>
			</div>
			<button class="next-btn" @click="nextImage" v-if="images.length > 3">
				<img src="../assets/MyOrder/iconI.png">
			</button>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			images: {
				type: Array,
				default: () => []
			}
		},
		watch: {
			images: {
				handler(newValue) {
					if (newValue.length > 0) {
						this.selectedImage = newValue[0]
					}
					console.log('数据', newValue)
				},
				deep: true
			}
		},
		data() {
			return {
				selectedImage: this.images[0],
			}
		},
		methods: {
			prevImage() {
				const currentIndex = this.images.indexOf(this.selectedImage);
				const prevIndex = (currentIndex - 1 + this.images.length) % this.images.length;
				this.selectedImage = this.images[prevIndex]; // 切换到上一张图片
				this.scrollToImage(this.selectedImage); // 切换图片时自动滚动
			},
			nextImage() {
				const currentIndex = this.images.indexOf(this.selectedImage);
				const nextIndex = (currentIndex + 1) % this.images.length;
				this.selectedImage = this.images[nextIndex]; // 切换到下一张图片
				this.scrollToImage(this.selectedImage); // 切换图片时自动滚动
			},
			scrollToImage(image) {
				const container = this.$refs.thumbnailContainer;
				const currentIndex = this.images.indexOf(image);
				const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
				const thumbnailWidth = .92 * rootFontSize; // 每个缩略图的宽度，包括间隔
				const maxVisibleThumbnails = 3; // 显示的最大缩略图数量
				console.log(container)
				// 计算当前选中缩略图的偏移量
				const thumbnailOffset = currentIndex * thumbnailWidth;

				// 计算需要滚动的距离，保持最多显示3个缩略图
				if (thumbnailOffset >= container.scrollLeft + maxVisibleThumbnails * thumbnailWidth) {
					// 向右滚动
					container.scrollLeft = thumbnailOffset - maxVisibleThumbnails * thumbnailWidth + thumbnailWidth;
				} else if (thumbnailOffset < container.scrollLeft) {
					// 向左滚动
					container.scrollLeft = thumbnailOffset;
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.image-gallery {
		display: flex;
		align-items: center;
	}

	.thumbnails-box {
		height: .86rem;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
	}

	.prev-btn,
	.next-btn {
		position: absolute;
		width: .12rem;
		height: .28rem;
		padding: 0 0;

		img {
			width: .12rem;
			height: .28rem;
		}
	}

	.prev-btn {
		top: calc(50% - .14rem);
		left: 0;
	}

	.next-btn {
		top: calc(50% - .14rem);
		right: 0;
	}

	.thumbnails-container {
		margin-left: .24rem;
		margin-right: .24rem;
		height: .86rem;
		width: 2.7rem;
		overflow-x: auto;
		scrollbar-width: none;
	}

	.thumbnails-container::-webkit-scrollbar {
		display: none;
	}

	.thumbnails {
		display: flex;
	}

	.thumbnail {
		flex-shrink: 0;
		cursor: pointer;
		width: .86rem;
		height: .86rem;
		margin-right: .06rem;
	}

	.thumbnail img {
		width: .86rem;
		height: .86rem;
		object-fit: cover;
		border-radius: .08rem;
	}

	.active {
		border: .02rem solid #f39c12;
		/* 激活状态的缩略图边框 */
	}
</style>